import { render, staticRenderFns } from "./ResponseError.vue?vue&type=template&id=510229d0&scoped=true"
import script from "./ResponseError.vue?vue&type=script&lang=js"
export * from "./ResponseError.vue?vue&type=script&lang=js"
import style0 from "./ResponseError.vue?vue&type=style&index=0&id=510229d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510229d0",
  null
  
)

export default component.exports